"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noticeHistoryReducer = exports.noticeHistoryActions = exports.TYPES = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'History';

// 初期状態
const INIT_STATE = {
  containerInfo: {
    dispContent: _Consts.CONSTS.CONTENTS.HISTORY,
    previousContent: _Consts.CONSTS.CONTENTS.MENU,
    entranceContent: _Consts.CONSTS.CONTENTS.MENU
  },
  history: {
    historyList: [],
    targetHistory: {},
    scrollTop: {
      index: 0,
      scrollY: 0,
      noSticky: false
    },
    paging: {
      viewNum: 50,
      currentPage: 0
    }
  },
  entries: {},
  initDisasterComplete: false,
  initNoticeKbnComplete: false,
  // 再検索用フラグ
  search: false
};
const TYPES = exports.TYPES = {
  // スクロール位置を変更
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  // ページ変更
  CHANGE_PAGE: PREFIX + 'ChangePage',
  // １ページの表示件数を変更
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  // 履歴情報の設定
  SET_HISTORY: PREFIX + 'SetHistory',
  // 登録／更新内容を項目ごとに設定
  SET_ENTRY: PREFIX + 'SetEntry',
  // 詳細情報の設定
  SET_ENTRIES: PREFIX + 'SetEntries',
  // 遷移元の設定
  SET_ENTRANCE_CONTENT: PREFIX + 'SetEntranceContent',
  // メンテナンス情報履歴画面遷移
  GO_HISTORY: PREFIX + 'GoHistory',
  // メンテナンス情報詳細画面遷移
  GO_DETAIL: PREFIX + 'GoDetail',
  // メンテナンス情報更新画面遷移
  GO_UPDATE_ENTRY: PREFIX + 'GoUpdateEntry',
  // メンテナンス情報更新結果画面遷移
  GO_UPDATE_RESULT: PREFIX + 'GoUpdateResult',
  // 初期状態にする
  CLEAR: PREFIX + 'Clear'
};
const noticeHistoryActions = exports.noticeHistoryActions = (0, _reduxActions.createActions)({
  // 履歴情報の設定
  [TYPES.SET_HISTORY]: function () {
    return {
      historyList: arguments.length <= 0 ? undefined : arguments[0],
      hasUpdate: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 登録／更新内容を項目ごとに設定
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 詳細情報の設定
  [TYPES.SET_ENTRIES]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0],
      dispContent: arguments.length <= 1 ? undefined : arguments[1],
      previousContent: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  // スクロール位置を変更
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      scrollTop: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // ページ変更
  [TYPES.CHANGE_PAGE]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      currentPage: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // １ページの表示件数を変更
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      viewNum: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 遷移元の設定
  [TYPES.SET_ENTRANCE_CONTENT]: function () {
    return {
      entranceContent: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // メンテナンス情報履歴画面遷移
  [TYPES.GO_HISTORY]: function () {
    return {
      targetHistory: arguments.length <= 0 ? undefined : arguments[0],
      previousContent: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // メンテナンス情報詳細画面遷移
  [TYPES.GO_DETAIL]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0],
      previousContent: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // メンテナンス情報更新画面遷移
  [TYPES.GO_UPDATE_ENTRY]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0],
      previousContent: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // メンテナンス情報更新結果画面遷移
  [TYPES.GO_UPDATE_RESULT]: function () {
    return {
      previousContent: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
},
// 初期状態にする
TYPES.CLEAR);
const noticeHistoryReducer = exports.noticeHistoryReducer = (0, _reduxActions.handleActions)({
  // 履歴情報の設定
  [TYPES.SET_HISTORY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      history: _objectSpread(_objectSpread({}, state.history), {}, {
        historyList: action.payload.historyList,
        hasUpdate: action.payload.hasUpdate
      })
    });
  },
  // 登録／更新内容を項目ごとに設定
  [TYPES.SET_ENTRY]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    entries: _objectSpread(_objectSpread({}, state.entries), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  // 詳細情報の設定
  [TYPES.SET_ENTRIES]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: action.payload.entries,
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        dispContent: action.payload.dispContent,
        previousContent: action.payload.previousContent
      })
    });
  },
  // スクロール位置を変更
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      [action.payload.key]: _objectSpread(_objectSpread({}, state[action.payload.key]), {}, {
        scrollTop: action.payload.scrollTop
      })
    });
  },
  // ページ変更
  [TYPES.CHANGE_PAGE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      [action.payload.key]: _objectSpread(_objectSpread({}, state[action.payload.key]), {}, {
        paging: _objectSpread(_objectSpread({}, state[action.payload.key].paging), {}, {
          currentPage: action.payload.currentPage
        })
      })
    });
  },
  // １ページの表示件数を変更
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      [action.payload.key]: _objectSpread(_objectSpread({}, state[action.payload.key]), {}, {
        paging: _objectSpread(_objectSpread({}, state[action.payload.key].paging), {}, {
          currentPage: 0,
          viewNum: action.payload.viewNum
        })
      })
    });
  },
  // 遷移元の設定
  [TYPES.SET_ENTRANCE_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        entranceContent: action.payload.entranceContent
      })
    });
  },
  // メンテナンス情報履歴画面遷移
  [TYPES.GO_HISTORY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      history: _objectSpread(_objectSpread({}, state.history), {}, {
        targetHistory: action.payload.targetHistory ? action.payload.targetHistory : state.history.targetHistory
      }),
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        dispContent: _Consts.CONSTS.CONTENTS.HISTORY,
        previousContent: action.payload.previousContent
      })
    });
  },
  // メンテナンス情報詳細画面遷移
  [TYPES.GO_DETAIL]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: action.payload.entries,
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        dispContent: _Consts.CONSTS.CONTENTS.DETAIL,
        previousContent: action.payload.previousContent
      })
    });
  },
  // メンテナンス情報更新画面遷移
  [TYPES.GO_UPDATE_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: action.payload.entries,
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        dispContent: _Consts.CONSTS.CONTENTS.UPDATE_ENTRY,
        previousContent: action.payload.previousContent
      })
    });
  },
  // メンテナンス情報更新結果画面遷移
  [TYPES.GO_UPDATE_RESULT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        dispContent: _Consts.CONSTS.CONTENTS.UPDATE_RESULT,
        previousContent: action.payload.previousContent
      }),
      // 再検索用フラグ（履歴一覧を再描画する）
      search: true
    });
  },
  // 初期状態にする
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);